import { useRef, useEffect } from "react"
import { motion, useAnimation, useInView } from "framer-motion";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { featuredFirms } from "@/services/start/getFeatureFirms";
import useCarousel from "@/hooks/start/useCarousel.js";  

function FeaturedLawFirms() {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const { carouselRef, canScrollLeft, canScrollRight, scrollCarousel } = useCarousel(); // Using the hook

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [controls, isInView]);

  return (
    <section ref={ref} className="py-16 bg-[var(--navy-blue-light)] ">
      <div className="container mx-auto px-4">
        <motion.div
          initial="hidden"
          animate={controls}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
          }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold mb-4 text-white">Bufetes Destacados</h2>
          <div className="w-24 h-1 bg-[var(--gold)] mx-auto mb-6"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Descubre los bufetes de abogados más destacados en nuestra plataforma, reconocidos por su excelencia y
            profesionalismo.
          </p>
        </motion.div>

        <div className="relative">
          <motion.div
            ref={carouselRef}
            className="flex overflow-x-hidden gap-6 pb-4"
            initial="hidden"
            animate={controls}
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
            }}
          >
            {featuredFirms.map((firm) => (
              <motion.div
                key={firm.id}
                className="flex-none w-72 bg-white rounded-lg shadow-lg overflow-hidden"
                variants={{
                  hidden: { opacity: 0, scale: 0.8 },
                  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
                }}
              >
                <img src={firm.image || "/placeholder.svg"} alt={firm.name} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">{firm.name}</h3>
                  <p className="text-gray-600 mb-4">{firm.specialty}</p>
                  <div className="flex items-center">
                    <div className="flex text-yellow-400 mr-2">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className={i < Math.floor(firm.rating) ? "text-yellow-400" : "text-gray-300"} />
                      ))}
                    </div>
                    <span className="text-gray-600">{firm.rating.toFixed(1)}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <button
            onClick={() => scrollCarousel("left")}
            className={`absolute left-0 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md text-blue-600 hover:bg-blue-50 transition-all ${
              canScrollLeft ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
            aria-label="Scroll left"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={() => scrollCarousel("right")}
            className={`absolute right-0 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md text-blue-600 hover:bg-blue-50 transition-all ${
              canScrollRight ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
            aria-label="Scroll right"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
}

export default FeaturedLawFirms;


